import React, { FC, useRef } from 'react';
import { useFrame, useThree } from '@react-three/fiber';
import { Ship } from '../../../../components/Ship';
import { ShipConfig } from '../../../../types';

export type SpinningShipProps = {
  shipConfig: ShipConfig;
};

export const SpinningShip: FC<SpinningShipProps> = ({ shipConfig }) => {
  const groupRef = useRef<any>();

  const { clock } = useThree();
  useFrame(() => {
    if (groupRef.current) {
      // groupRef.current.position.z = Math.sin(clock.elapsedTime * 4) * 1;
      groupRef.current.rotation.y = clock.elapsedTime / 1.5;
    }
  });

  return (
    <Ship
      shipConfig={shipConfig}
      position={[0, 0, -2]}
      rotation={[Math.PI / 2, 0, 0]}
      groupRef={el => (groupRef.current = el)}
    />
  );
};
